var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCaption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 56,
    viewBox: "0 0 129 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 55,
    height: 35,
    rx: 0.5,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 35 55)",
    fill: "#EDF3FF",
    fillOpacity: 0.2,
    stroke: "#4680FF",
    strokeDasharray: "1 1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 8.29639,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 8.29639)",
    fill: "#7EA6FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 6.22217,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 6.22217)",
    fill: "#7EA6FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 4.14795,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 4.14795)",
    fill: "#7EA6FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 29.0371,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 29.0371)",
    fill: "#7EA6FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 26.9629,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 26.9629)",
    fill: "#7EA6FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 24.8887,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 24.8887)",
    fill: "#7EA6FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22.8149,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 22.8149)",
    fill: "#7EA6FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 10.3706,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 10.3706)",
    fill: "#7EA6FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 31.1113,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 31.1113)",
    fill: "#7EA6FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.03704,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 31.9971 13.4814)",
    fill: "#7EA6FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1.03704,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 31.9971 34.2222)",
    fill: "#7EA6FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 1.03704,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 31.9971 17.6294)",
    fill: "#7EA6FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 1.03704,
    height: 28,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 32 38.3706)",
    fill: "#7EA6FF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 14.5186,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 14.5186)",
    fill: "#7EA6FF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 35.2593,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 35.2593)",
    fill: "#7EA6FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 18.6665,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 18.6665)",
    fill: "#7EA6FF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 39.4072,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 39.4072)",
    fill: "#7EA6FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 41.4814,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 41.4814)",
    fill: "#7EA6FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 43.5557,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 43.5557)",
    fill: "#7EA6FF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9971,
    y: 45.6294,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 31.9971 45.6294)",
    fill: "#7EA6FF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 47.7036,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 47.7036)",
    fill: "#7EA6FF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 49.7778,
    width: 1.03704,
    height: 28,
    transform: "rotate(90 32 49.7778)",
    fill: "#7EA6FF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 42,
    height: 87,
    rx: 1.5,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 128 55)",
    fill: "#EDF3FF",
    fillOpacity: 0.4,
    stroke: "#7EA6FF",
    strokeDasharray: "1 1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 8.99999,
    height: 87,
    rx: 0.5,
    transform: "matrix(3.12544e-08 -1 -1 -6.11333e-08 127.997 9)",
    fill: "#EDF3FF",
    fillOpacity: 0.4,
    stroke: "#7EA6FF",
    strokeDasharray: "1 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCaption);
export default __webpack_public_path__ + "static/media/no-caption.29133c6e2b291b5894d466b6f0a8922b.svg";
export { ForwardRef as ReactComponent };